import app from '@/app';

/* @ngInject */
function Vrd($resource) {
	return $resource(
		'api/vrds/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Vrd', Vrd);
